// React
import React, { useContext, useEffect, useRef, useState } from 'react'
import { StateContext } from '../App'

// Localization
import { FormattedMessage, useIntl } from 'react-intl'

// Survey helpers (shared with other Papunet React apps)
import {
  getKyselyCookieName,
  getKyselyUrl,
  hasKyselyDismissCookie,
  isKyselyCampaignActive,
  setKyselyDismissCookie,
} from '../utils/kyselySurvey.js'

// Styles
import '../styles/KyselyNotification.scss'

const KyselyNotification = () => {
  const intl = useIntl()
  const ctx = useContext(StateContext)
  const state = ctx[0]
  const { lang } = state
  const dontShowAgainRef = useRef(null)

  const cookieName = getKyselyCookieName(lang)
  const kyselyUrl = getKyselyUrl(lang)

  const [visible, setVisible] = useState(false)

  useEffect(() => {
    if (!isKyselyCampaignActive()) {
      setVisible(false)
      return
    }
    setVisible(!hasKyselyDismissCookie(cookieName))
  }, [cookieName])

  function closePopup() {
    if (dontShowAgainRef.current?.checked) {
      setKyselyDismissCookie(cookieName)
    }
    setVisible(false)
  }

  if (!visible) {
    return null
  }

  return (
    <div className="kysely-notification">
      <div className="popup">
        <button
          className="close-btn"
          onClick={closePopup}
          aria-label={intl.formatMessage({ id: 'Kysely.Close' })}
          type="button"
        >
          X
        </button>
        <h2>
          <FormattedMessage id="Kysely.Heading" />
        </h2>
        <p>
          <FormattedMessage id="Kysely.FirstParagraph" />
        </p>
        <p>
          <FormattedMessage id="Kysely.SecondParagraph" />
        </p>
        <a href={kyselyUrl} target="_blank" rel="noreferrer noopener">
          <FormattedMessage id="Kysely.Link" />
        </a>
        <div className="checkbox-container">
          <input
            ref={dontShowAgainRef}
            type="checkbox"
            id="kysely-dont-show-again"
            name="dont-show-again"
          />
          <label htmlFor="kysely-dont-show-again">
            <FormattedMessage id="Kysely.DontShowAgain" />
          </label>
        </div>
        <button type="button" onClick={closePopup}>
          <FormattedMessage id="Kysely.Close" />
        </button>
      </div>
    </div>
  )
}

export default KyselyNotification
